import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

function getInitialState() {
  return {
    selectedProject: null,
    country: null,
    pageSetting: {
      alert: false,
      battery: false,
      financial: false,
      nem12: false,
      energyDemandName: 'Energy Demand',
      solarConsumedName: 'Solar Consumed',
      solarDeliveredName: 'Solar Delivered',
      solarExportedName: 'Solar Exported',
      stackConsumedExportedCurve: false,
      showBilling: false,
    },
    financial: {
      solarAccessFee: {
        inputTariff: null,
        exportTariff: null,
        solarConnectionFee: null,
      },
    },
    isFetching: false,
    isForbidden: false,
  };
}

export default createStore({
  state: getInitialState(),
  mutations: {
    setCountry(state, country) {
      state.country = country;
    },
    setPageSetting(state, setting) {
      state.pageSetting = setting;
    },
    setSelectedProject(state, project) {
      state.selectedProject = project;
    },
    setSolarAccessFee(state, fee) {
      if (Array.isArray(fee)) {
        if (fee.length > 0) {
          state.financial.solarAccessFee = fee[0];
        } else if (fee.length === 0) {
          state.financial.solarAccessFee = {
            inputTariff: null,
            exportTariff: null,
            solarConnectionFee: null,
          };
        }
      }
    },
    setShowBilling(state, showBilling) {
      state.pageSetting.showBilling = showBilling;
    },
    setIsFetching(state, isFetching) {
      state.isFetching = isFetching;
    },
    setForbidden(state, isForbidden) {
      state.isForbidden = isForbidden;
    },
    resetStore(state) {
      Object.assign(state, getInitialState());
    },
  },
  getters: {
    isDisplayTabBar: (state) => state.pageSetting.alert || state.pageSetting.battery,
  },
  modules: {},
  plugins: [createPersistedState()],
});
